import { ref, onMounted } from 'vue';

export function useTenantSplashScreen() {
  const splashScreenUrl = ref('/assets/splash_screen_fallback.png');

  const checkImageExists = (url: string): Promise<boolean> => {
    return new Promise((resolve) => {
      const img = new Image();
      img.onload = () => resolve(true);
      img.onerror = () => resolve(false);
      img.src = url;
    });
  };

  onMounted(async () => {
    const splashScreenPaths = ['/assets/splash_screen.png', '/assets/splash_screen.jpg'];

    for (const path of splashScreenPaths) {
      if (await checkImageExists(path)) {
        splashScreenUrl.value = `${path}?t=${Date.now()}`;
        break;
      }
    }
  });

  return {
    splashScreenUrl,
  };
}
